import React from 'react';
import { Block } from '../../core';
import type { HoldingsBreakdownType } from '../../../../studio-blocks/types';

interface HoldingsCalculationInfoProps {
  breakdownType: HoldingsBreakdownType;
}

export const HoldingsCalculationInfo = ({ breakdownType }: HoldingsCalculationInfoProps) => {
  return <Block.MetadataItem iconType="info-circle">{breakdownType}</Block.MetadataItem>;
};
